import { Button } from '@qr-front/ui/components/Button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogTitle,
} from '@qr-front/ui/components/Dialog'

export type TCancelSubscriptionSuccessDialogProps = {
	isOpen: boolean
	onClose: () => void
	translations: {
		closeButtonLabel: string
		title: string
		description: string
		submit: string
	}
}

export const CancelSubscriptionSuccessDialog = ({
	isOpen,
	onClose,
	translations,
}: TCancelSubscriptionSuccessDialogProps) => {
	const handleCloseDialog = () => {
		onClose?.()
	}

	return (
		<Dialog open={isOpen} onOpenChange={handleCloseDialog}>
			<DialogContent
				closeButtonLabel={translations.closeButtonLabel}
				className="max-w-[350px] p-0 desktop:max-w-[400px]"
			>
				<div className="p-6 text-center desktop:p-8">
					<DialogTitle>{translations.title}</DialogTitle>
					<DialogDescription className="mt-2 text-dark-grey">
						{translations.description}
					</DialogDescription>
					<DialogFooter className="mt-6">
						<Button
							size="large"
							onClick={handleCloseDialog}
							className="focus-visible:outline-none"
						>
							{translations.submit}
						</Button>
					</DialogFooter>
				</div>
			</DialogContent>
		</Dialog>
	)
}
